import { Box } from '@mui/material';
import { SvgImage } from 'components/images/SvgImage';
import { Logo } from 'greener-ui-library';
import { Blueprint } from 'types';

interface ProjectPartnerLogoProps {
  blueprintDetails: Blueprint;
  height?: number | string;
}

export const ProjectPartnerLogo = ({ blueprintDetails, height = '60px' }: ProjectPartnerLogoProps) => {
  if (!blueprintDetails) {
    return null;
  }

  const logoOrg = blueprintDetails.partnerOrganisation ?? blueprintDetails.organisation;
  const logoUrl = logoOrg?.logoUrl;

  return (
    <Box height={height}>
      <Logo
        logoUrl={logoUrl}
        height={height}
        width={logoUrl ? 'auto' : 60}
        representativeChar={logoOrg?.name?.charAt(0)}
        svgImage={logoUrl ? <SvgImage logoUrl={logoUrl} /> : undefined}
        imagePosition="left center"
      />
    </Box>
  );
};
